import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';

export type AdminStatCardVariant = 'cyan' | 'green' | 'sunset';

interface AdminStatCardProps {
  label: string;
  value: string | number;
  subtitle: string;
  icon?: ReactNode;
  variant: AdminStatCardVariant;
}

const VARIANT_CLASS: Record<AdminStatCardVariant, string> = {
  cyan: 'admin-stat-card--cyan',
  green: 'admin-stat-card--green',
  sunset: 'admin-stat-card--sunset',
};

export default function AdminStatCard({
  label,
  value,
  subtitle,
  icon,
  variant,
}: AdminStatCardProps) {
  return (
    <Box className={`admin-stat-card ${VARIANT_CLASS[variant]}`}>
      <p className="admin-stat-card__value">{value}</p>
      <Box className="admin-stat-card__text">
        <Typography className="admin-stat-card__label" component="p">
          {label}
        </Typography>
        <Box className="admin-stat-card__subtitle-row">
          {icon && <span className="admin-stat-card__icon">{icon}</span>}
          <Typography className="admin-stat-card__subtitle" component="p">
            {subtitle}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
